import objectPath from 'object-path'

const getters = {
  getLoginForm: state => state.loginForm,
  getLoginFormErrors: state => state.loginFormErrors,
  getFormField: state => target => objectPath.get(state, target),
  isLoading: state => state.isLoading,
  getAccess: state => state.access,
  getApiKey: state => state.apiKey,
  checkMainAccess: state => state.accesses.main,
  checkContactsAccess: state => state.accesses.contacts,
  checkCountriesAccess: state => state.accesses.countries,
  checkNestedForGuestsAccess: state => state.accesses.nestedForGuests,
  checkNestedForAgentsAccess: state => state.accesses.nestedForAgents,
  checkNestedForIndividualsAccess: state => state.accesses.nestedForIndividuals,
  checkFavoritesAccess: state => state.accesses.favorites,
  checkLkAccess: state => state.accesses.lk,
  checkSearchAccess: state => state.accesses.search,
  checkResultAccess: state => state.accesses.result,
  checkCartAccess: state => state.accesses.cart,
  checkPriceAccess: state => state.accesses.price,
  checkBookingAccess: state => state.accesses.booking,
  checkAgencyPriceAccess: state => state.accesses.agencyPrice,
  checkOrdersAccess: state => state.accesses.orders,
  checkSaleAccess: state => state.accesses.sale,
  checkEditSaleAccess: state => state.accesses.editSale,
  checkEventsAccess: state => state.accesses.events,
  checkEditEventsAccess: state => state.accesses.editEvents,
  checkEditBannerAccess: state => state.accesses.editBanner,
  checkPhonesForIndividualsAccess: state => state.accesses.phonesForIndividuals,
  checkPhonesForAgentsAccess: state => state.accesses.phonesForAgents,
}

export default getters